import { Checkbox, Form, Row, Select } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { setSelectedClaims } from '../../../store/actions/grievanceAction';
import { changePayer } from '../../../store/actions/payerListAction';
import { GrievanceModel } from '../../../store/models/grievanceModel';
import { Payer } from '../../models/payer.model';
import useSetDefaultPayer from '../../hooks/useSetDefaultPayer';

const ClaimListActions = ({ record }: any): ReactElement => {
  const { payerId, productCode } = record || {};
  const uniqId = `${payerId}${productCode || ''}`;
  const dispatch = useDispatch();
  const { selectedClaimsList, currentlyEnabledPayer } = useSelector((state: RootState): GrievanceModel => state?.grievance || {});
  const payerList = useSelector((state: RootState): Payer[] => state?.payerList?.allPayers || []);
  const { lookUp: { allGrievances = {} } } = useSelector((state: RootState): any => state || {});
  const [disabled, setIsDisabled] = useState(false);
  const defaultPayer = useSetDefaultPayer();

  const changeAction = (selectedActionValue: any): void => {
    if (selectedActionValue) {
      const listToUpdate = { ...selectedClaimsList };
      listToUpdate[record?.hospActionId] = record;
      listToUpdate[record?.hospActionId].grievanceType = selectedActionValue;
      dispatch(setSelectedClaims(listToUpdate));
      updatePayer();
    }
  };

  const updatePayer = (): any => {
    const currUniqId = `${record?.payerId}${record?.productCode || ''}`;
    const selectedPayer = payerList.find((ele: Payer): boolean => ele?.uniqueIdentifier === currUniqId);
    dispatch(changePayer(selectedPayer || defaultPayer));
  };

  const changeCheck = (selectedCheckValue: any): void => {
    if (selectedCheckValue?.target?.checked) {
      const listToUpdate = { ...selectedClaimsList };
      listToUpdate[record?.hospActionId] = record;
      listToUpdate[record?.hospActionId].isSelected = selectedCheckValue?.target?.checked;
      dispatch(setSelectedClaims(listToUpdate));
      updatePayer();
    } else {
      const listToUpdate = { ...selectedClaimsList };
      delete listToUpdate[record?.hospActionId];
      dispatch(setSelectedClaims(listToUpdate));
    }
  };

  useEffect((): any => {
    if (currentlyEnabledPayer) {
      const uniqPayerId = `${record?.payerId}${record?.productCode || ''}`;
      if (currentlyEnabledPayer !== uniqPayerId) {
        setIsDisabled(true);
      } else {
        setIsDisabled(false);
      }
    } else {
      setIsDisabled(false);
    }
  }, [currentlyEnabledPayer]);

  return (
    <React.Fragment>
      <Row>
        <Form.Item name={record.hospActionId + '_GRIEVANCESELECT'} valuePropName="checked">
          <Checkbox onChange={changeCheck} disabled={disabled}/>
        </Form.Item>
        <Form.Item className="margin-select" name={record.hospActionId + '_GRIEVANCETYPE'}>
          <Select
            className="width-select"
            data-testid="inpatient-filter"
            showSearch={true}
            placeholder="Select"
            optionFilterProp="children"
            onChange={changeAction}
            disabled={disabled}
            options={allGrievances[uniqId] || []}
            filterOption={(input: any, option: any): any =>
              option?.label?.toLowerCase().indexOf(input?.toLowerCase()) >= 0 // Grievance search filter not showing fixed
            }
          />
        </Form.Item>
      </Row>
    </React.Fragment>
  );
};
export default ClaimListActions;
